import { useEffect, useState } from "react";

// "#/login" and "#/dashboard" are pages. "#about" stays a landing section.

function parse() {
  const hash = window.location.hash;
  if (!hash.startsWith("#/")) return { page: "home", path: "", parts: [], params: new URLSearchParams() };
  const [path, query = ""] = hash.slice(2).split("?");
  const parts = path.split("/").filter(Boolean);
  return { page: parts[0] || "home", path, parts, params: new URLSearchParams(query) };
}

export default function useHashRoute() {
  const [route, setRoute] = useState(parse);

  useEffect(() => {
    const onChange = () => setRoute(parse());
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);

  return route;
}

export function isMemberRoute(route) {
  const [area, section] = route.parts;
  if (["dashboard", "profile", "wallet", "earnings", "team", "rewards", "notifications", "support", "activity"].includes(area)) {
    return true;
  }
  return area === "packages" && (section === "buy" || section === "mine");
}
